import { render, staticRenderFns } from "./productCartVariant.vue?vue&type=template&id=abcd0e08&scoped=true"
import script from "./productCartVariant.vue?vue&type=script&setup=true&lang=js"
export * from "./productCartVariant.vue?vue&type=script&setup=true&lang=js"
import style0 from "./productCartVariant.vue?vue&type=style&index=0&id=abcd0e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abcd0e08",
  null
  
)

export default component.exports